webpackJsonp([89027509443936],{

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/car-care-day.33a4a57e.jpg";

/***/ }),

/***/ 731:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dec-event2.b4041270.jpg";

/***/ }),

/***/ 732:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/justice.94a87a9a.jpg";

/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/soccer-stadium.3d69d342.jpg";

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  background-color: #d21618;\n  padding: 0.75rem 1.5rem;\n  color: #fff;\n  text-decoration: none;\n  margin-top: 1rem;\n'], ['\n  display: inline-block;\n  background-color: #d21618;\n  padding: 0.75rem 1.5rem;\n  color: #fff;\n  text-decoration: none;\n  margin-top: 1rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _PagePost = __webpack_require__(12);
	
	var _PagePost2 = _interopRequireDefault(_PagePost);
	
	var _Paragraph = __webpack_require__(16);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _FullWidth = __webpack_require__(8);
	
	var _FullWidth2 = _interopRequireDefault(_FullWidth);
	
	var _Container = __webpack_require__(6);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _PrimaryImage = __webpack_require__(21);
	
	var _PrimaryImage2 = _interopRequireDefault(_PrimaryImage);
	
	var _SuggestedPage = __webpack_require__(17);
	
	var _SuggestedPage2 = _interopRequireDefault(_SuggestedPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	// eslint-disable-next-line import/no-extraneous-dependencies
	
	// eslint-disable-next-line import/no-extraneous-dependencies
	
	
	var A = _styledComponents2.default.a(_templateObject);
	
	var PageDecEvent = function PageDecEvent() {
	  return _react2.default.createElement(
	    _PagePost2.default,
	    {
	      back: '#dec-event',
	      title: '\u7279\u5225\u6D3B\u52D5',
	      introduction: '\u9996\u5C46 Uber \u56DB\u4EBA\u5BA4\u5167\u8DB3\u7403\u5927\u8CFD\u5C07\u65BC12\u67089\u65E5\uFF08\u661F\u671F\u516D\uFF09\u8209\u884C\uFF01\u7ACB\u5373\u8207\u597D\u53CB\u7D44\u968A\u53C3\u8CFD\uFF0C\u6367\u8D70\u734E\u76C3\uFF01'
	    },
	    _react2.default.createElement(
	      _FullWidth2.default,
	      null,
	      _react2.default.createElement(
	        _Container2.default,
	        { padding: '3rem 3rem 1rem' },
	        _react2.default.createElement(_PrimaryImage2.default, { src: __webpack_require__(731) }),
	        _react2.default.createElement(
	          _Paragraph2.default,
	          null,
	          '\u9996\u5C46 \u300CUber \u56DB\u4EBA\u5BA4\u5167\u8DB3\u7403\u5927\u8CFD \u300D\u5373\u5C07\u8209\u884C\uFF01\u6211\u5011\u8AA0\u9080\u4F60\u8207\u670B\u53CB\u7D44\u968A\u53C3\u52A012\u67089\u65E5\u65BC\u89C0\u5858\u8209\u884C\u7684\u56DB\u4EBA\u8DB3\u7403\u5927\u8CFD\u3002\u5C46\u6642\u66FE\u7576\u9078\u300C\u9999\u6E2F\u8DB3\u7403\u5148\u751F\u300D\u7684\u524D\u6E2F\u8DB3\u540D\u5BBF\u9673\u70B3\u5B89\u6703\u5750\u93AE\uFF0C\u6307\u9EDE\u7403\u6280\u3001\u5206\u4EAB\u6BD4\u8CFD\u5FC3\u5F97\uFF0C\u4E26\u9812\u767C\u7531 Uber \u63D0\u4F9B\u53CA\u98DB\u9F8D\u7403\u5834\u8D0A\u52A9\u3001\u7E3D\u503CHK$10,000\u7684\u8C50\u539A\u734E\u54C1\u3002'
	        ),
	        _react2.default.createElement(
	          _Paragraph2.default,
	          null,
	          '\u540D\u984D\u6709\u9650\uFF0C\u7ACB\u5373\u8207\u597D\u53CB\u7D44\u968A\u53C3\u8CFD\uFF0C\u6367\u8D70\u734E\u76C3\uFF01 \u6B61\u8FCE\u89AA\u53CB\u5230\u5834\u6253\u6C23\u89C0\u8CFD\uFF01'
	        ),
	        _react2.default.createElement(
	          _Paragraph2.default,
	          null,
	          '\u65E5\u671F\u53CA\u6642\u9593\uFF1A12\u67089\u65E5 \uFF08\u661F\u671F\u516D\uFF0912:00 - 7:00 pm',
	          _react2.default.createElement('br', null),
	          '\u5730\u9EDE\uFF1A \u98DB\u9F8D\u5BA4\u5167\u8DB3\u7403\u5834',
	          _react2.default.createElement('br', null),
	          '\u5730\u5740\uFF1A \u4E5D\u9F8D\u89C0\u5858\u89C0\u5858\u9053398-402\u865F\u5609\u57DF\u5927\u5EC86\u6A13'
	        ),
	        _react2.default.createElement(
	          _Paragraph2.default,
	          null,
	          _react2.default.createElement(
	            A,
	            {
	              target: '_blank',
	              rel: 'noopener noreferrer',
	              href: 'https://docs.google.com/forms/d/e/1FAIpQLSfVDPR8m9IaSt0yMHIlQU_mdDsimWQR3Kk8MVuW4BZuZmca5w/viewform'
	            },
	            '\u4E86\u89E3\u66F4\u591A'
	          )
	        ),
	        _react2.default.createElement(_PrimaryImage2.default, { src: __webpack_require__(733) }),
	        _react2.default.createElement(
	          'h3',
	          null,
	          '\u6D3B\u52D5\u56DE\u9867 - \u300A\u6B63\u7FA9\u806F\u76DF\u300B\u96FB\u5F71\u653E\u9001\u6703'
	        ),
	        _react2.default.createElement(
	          _Paragraph2.default,
	          null,
	          'Uber \u65BC11\u670819\u65E5\u5305\u5834\u8ACB\u53F8\u6A5F\u5925\u4F34\u4E00\u5BB6\u89C0\u8CDEDC\u6700\u65B0\u529B\u4F5C\u300A\u6B63\u7FA9\u806F\u76DF\u300B\u3002\u7576\u65E5\u5EA7\u7121\u865B\u5E2D\uFF0C\u5927\u5BB6\u4E00\u908A\u4EAB\u7528\u7206\u8C37\u3001\u98F2\u54C1\uFF0C\u4E00\u908A\u6295\u5165\u96FB\u5F71\u7576\u4E2D\uFF0C\u5EA6\u904E\u4E86\u71B1\u9B27\u6B61\u6109\u7684\u4E00\u65E5\u3002'
	        ),
	        _react2.default.createElement(_PrimaryImage2.default, { src: __webpack_require__(732) }),
	        _react2.default.createElement(
	          'h3',
	          null,
	          '\u6D3B\u52D5\u56DE\u9867 - Uber x Motor City \u6C7D\u8ECA\u8A66\u99D5\u53CA\u4FDD\u990A\u65E5'
	        ),
	        _react2.default.createElement(
	          _Paragraph2.default,
	          null,
	          '11\u670815\u65E5\uFF0C\u8FD1 80 \u4F4D\u53F8\u6A5F\u5925\u4F34\u51FA\u5E2D\u4E86 Uber x Motor City \u6C7D\u8ECA\u8A66\u99D5\u53CA\u4FDD\u990A\u65E5\uFF0C\u5927\u5BB6\u90FD\u8E34\u8E8D\u5C31\u6C7D\u8ECA\u4FDD\u990A\u3001\u7CBE\u660E\u99D5\u99DB\u548C\u6173\u6CB9\u8CBC\u58EB\u767C\u554F\u3002\u6D3B\u52D5\u7576\u65E5\u4EA6\u5B89\u6392\u4E86\u591A\u500B\u8ECA\u6B3E\u4F9B\u53F8\u6A5F\u5925\u4F34\u8A66\u8ECA\uFF0C\u7576\u4E2D\u96FB\u52D5\u8ECA Tesla \u7CFB\u5217\u6700\u53D7\u6B61\u8FCE\u3002\u800C\u5728\u5927\u62BD\u734E\u74B0\u7BC0\u4E2D\uFF0C\u5E78\u904B\u5152\u7372\u8D08 GoGoWash \u514D\u8CBB\u6D17\u8ECA\u6216\u6D17\u5048\u670D\u52D9\uFF0C\u4EE5\u53CA Uber \u7CBE\u7F8E\u79AE\u54C1\uFF0C\u4EBA\u4EBA\u6EFF\u8F09\u800C\u6B78\u3002'
	        ),
	        _react2.default.createElement(_PrimaryImage2.default, { src: __webpack_require__(730) })
	      ),
	      _react2.default.createElement(
	        _Container2.default,
	        { padding: '3rem' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          '\u5176\u4ED6\u76F8\u95DC\u6D3B\u52D5'
	        ),
	        _react2.default.createElement(
	          _SuggestedPage2.default,
	          {
	            to: '/yearend-party',
	            bg: __webpack_require__(187)
	          },
	          '2017\u5E74\u6176\u795D\u6D3E\u5C0D\u66A8\u300C123\u65E5\u6539\u8B8A\u300D\u56DE\u9867'
	        ),
	        _react2.default.createElement(
	          _SuggestedPage2.default,
	          {
	            to: '/monthly-star',
	            bg: __webpack_require__(180)
	          },
	          '\u6BCF\u6708\u4E4B\u661F'
	        )
	      )
	    )
	  );
	};
	
	exports.default = PageDecEvent;
	module.exports = exports['default'];

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PageDecEvent = __webpack_require__(353);
	
	var _PageDecEvent2 = _interopRequireDefault(_PageDecEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PageDecEvent2.default;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-dec-event-jsx-6f840f6a6d4de02804bb.js